import React from 'react'

const InputDateJSX = ({ labelText, nameValue, value, onChange,minToday }) => {
    return (
        <>
            <div className="col-md-6 mt-2">
                <div className='ms-2'>
                    <label htmlFor="" className='form-label  mb-0'>
                        {labelText}
                    </label>
                    <div className="icon-forms mb-3 mb-sm-0">
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            id={nameValue}
                            name={nameValue}
                            value={value}
                            onChange={onChange}
                            min={minToday ? new Date().toISOString().split("T")[0] : "1900-01-01"}
                            // min={"1900-01-01"}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default InputDateJSX